<template>
  <div id="app">
    <!-- 路由占位符 -->
    <Top></Top>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import Top from '@/components/Top.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: 'app',
  components: {
    Top,
    Footer
  },
  data () {
    return {
      state: true
    }
  },
  methods: {
    // clickChangeLang (value) {
    //   console.log('clickChangeLang')
    //   this.$router.go(0)
    // }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
